import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../../components/Navbar";
import {
  Search,
  Download,
  UserPlus,
  Users,
  UserCheck,
  UserX,
  Filter,
  Plus,
} from "lucide-react";
import SenderTableComponent from "../../components/Senders/SenderTableComponent";
import {
  fetchSenders,
  fetchcampaignStats,
} from "../../requests/Sender_Ids/SenderService";
import ShimmerTableComponent from "../../components/ShimmerTableComponent";
import SenderIdShimmerComponent from "../../components/Senders/SenderIdShimmerComponent";
import StatCard from "../../components/Senders/StatCard";
import LoadErrorPlaceholder from "../../components/LoadErrorPlaceholder";
import { fetchCampaigns } from "../../requests/Campaigns/CampaignService";
import CampaignTableComponent from "../../components/Campaigns/CampaignTableComponent";

const Campaigns = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [selectedRows, setSelectedRows] = useState([]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };


  const handleSort = (key) => {
    setSortConfig((currentSort) => {
      if (currentSort.key === key) {
        return {
          key,
          direction:
            currentSort.direction === "ascending" ? "descending" : "ascending",
        };
      }
      return { key, direction: "ascending" };
    });
  };

  const handleSelectedRows = (rows) => {
    setSelectedRows(rows);
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState([true]);
  const [error, setError] = useState([null]);

  useEffect(() => {
    refreshData();
  }, []);

  const refreshData = () => {
    fetchCampaigns(setData, setLoading, setError);
  };

  return (
    <div>
      <Navbar page="Campaigns" />
      <div className="p-6 min-h-screen bg-slate-50">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="space-y-8"
        >
          {/* Header Section */}
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold text-gray-800">
              Campaign Management
            </h1>
          </div>

          {/* Stats Grid */}

          {loading ? (
            <SenderIdShimmerComponent />
          ) : error ? (
            <LoadErrorPlaceholder />
          ) : (
            <>
           
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
                
                  <StatCard
                    title="Total Campaigns"
                    subtitle="Registered accounts"
                    count={data.campaignStats.count_campaign}
                    change="12"
                    trend="up"
                    color="[#FF6C6C]"
                    icon=<Users className="w-6 h-6" />
                    itemVariants={itemVariants}
                  />
                  <StatCard
                    title="Approved"
                    subtitle="Currently verified"
                    count={data.campaignStats.count_approved_campaign}
                    change="12"
                    trend="up"
                    color="green"
                    icon=<UserCheck className="w-6 h-6" />
                    itemVariants={itemVariants}
                  />
                  <StatCard
                    title="Pending"
                    subtitle="Awaiting Approval"
                    count={data.campaignStats.count_pending_campaign}
                    change="8"
                    trend="up"
                    color="purple"
                    icon=<UserPlus className="w-6 h-6" />
                    itemVariants={itemVariants}
                  />
                  <StatCard
                    title="Rejected"
                    subtitle="Temporarily Blocked"
                    count={data.campaignStats.count_rejected_campaign}
                    change="4"
                    trend="down"
                    color="red"
                    icon=<UserX className="w-6 h-6" />
                    itemVariants={itemVariants}
                  />
                
              </div>
             

              {/* Table Section */}
              <motion.div
                variants={itemVariants}
                className="bg-white rounded-xl shadow-sm"
              >
                <div className="flex flex-wrap gap-4 justify-between items-center p-4 border-b">
                  <div className="flex gap-4">
                    <div className="relative">
                      <Search className="absolute left-3 top-1/2 w-5 h-5 text-gray-400 -translate-y-1/2" />
                      <input
                        type="text"
                        placeholder="Search campaigns..."
                        className="py-2 pr-4 pl-10 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <button
                      className={`flex items-center gap-2 px-4 py-2 border rounded-lg ${
                        selectedRows.length > 0
                          ? "bg-red-50 text-red-600 hover:bg-red-100 border-red-200"
                          : "bg-gray-50 text-gray-300 cursor-not-allowed"
                      }`}
                      disabled={selectedRows.length === 0}
                    >
                      Delete Selected
                    </button>
                    <button className="flex gap-2 items-center px-4 py-2 rounded-lg border hover:bg-gray-50">
                      <Download className="w-5 h-5" /> Export
                    </button>
                  </div>
                </div>

                {/* Table Component */}

                <CampaignTableComponent
                  data={data.campaignData}
                  searchTerm={searchTerm}
                  sortConfig={sortConfig}
                  onSort={handleSort}
                  onSuccess={refreshData}
                  // onError={onclose}
                  onSelectedRowsChange={handleSelectedRows}
                />
              </motion.div>
            </>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Campaigns;
